/************************************************************************
** IBM Confidential
**
** IBM Business Analytics: Rapidly Adaptive Visualization Engine
**
** (C) Copyright IBM Corp. 2018, 2019
**
** The source code for this program is not published or otherwise divested of its trade secrets, 
** irrespective of what has been deposited with the U.S. Copyright Office.
************************************************************************/

export default class FormatSymbols
{

	// used by junits
  	static GERMAN = 'de-DE';
	static ENGLISH = 'en-US';
   
    static CA_SUPPORTED ={
	"ar": ";",
	"ar_ae": ";",
	"ar_bh": ";",
	"ar_dz": ";",
	"ar_eg": ";",
	"ar_iq": ";",
	"ar_jo": ";",
	"ar_kw": ";",
	"ar_lb": ";",
	"ar_ly": ";",
	"ar_ma": ";",
	"ar_om": ";",
	"ar_qa": ";",
	"ar_sa": ";",
	"ar_sd": ";",
	"ar_sy": ";",
	"ar_tn": ";",
	"ar_ye": ";",
	"be": ";",
	"be_by": ";",
	"bg": ";",
	"bg_bg": ";",
	"bn_in": ";",
	"ca": ";",
	"ca_es": ";",
	"ca_es_preeuro": ";",
	"cs": ";",
	"cs_cz": ";",
	"cs_cz_preeuro": ";",
	"da": ";",
	"da_dk": ";",
	"de": ";",
	"de_at": ";",
	"de_at_preeuro": ";",
	"de_ch": ";",
	"de_de": ";",
	"de_de_preeuro": ";",
	"de_gr": ";",
	"de_lu": ";",
	"de_lu_preeuro": ";",
	"el": ";",
	"el_cy": ";",
	"el_cy_preeuro": ";",
	"el_gr": ";",
	"el_gr_preeuro": ";",
	"en_be": ";",
	"en_be_preeuro": ";",
	"en_hk": ";",
	"en_in": ";",
	"en_mt": ";",
	"en_ph": ";",
	"en_sg": ";",
	"en_za": ";",
	"es": ";",
	"es_ar": ";",
	"es_bo": ";",
	"es_cl": ";",
	"es_co": ";",
	"es_cr": ";",
	"es_cu": ";",
	"es_ec": ";",
	"es_es": ";",
	"es_es_preeuro": ";",
	"es_gt": ";",
	"es_hn": ";",
	"es_ni": ";",
	"es_pe": ";",
	"es_pr": ";",
	"es_py": ";",
	"es_sv": ";",
	"es_us": ";",
	"es_uy": ";",
	"es_ve": ";",
	"et": ";",
	"et_ee": ";",
	"et_ee_preeuro": ";",
	"fi": ";",
	"fi_fi": ";",
	"fi_fi_preeuro": ";",
	"fr": ";",
	"fr_be": ";",
	"fr_be_preeuro": ";",
	"fr_ca": ";",
	"fr_ch": ";",
	"fr_fr": ";",
	"fr_fr_preeuro": ";",
	"fr_lu": ";",
	"fr_lu_preeuro": ";",
	"ga": ";",
	"ga_ie": ";",
	"gu": ";",
	"gu_in": ";",
	"hr": ";",
	"hr_hr": ";",
	"hu": ";",
	"hu_hu": ";",
	"hu_hu_preeuro": ";",
	"in": ";",
	"in_id": ";",
	"is": ";",
	"is_is": ";",
	"it": ";",
	"it_ch": ";",
	"it_it": ";",
	"it_it_preeuro": ";",
	"kk": ";",
	"kk_kz": ";",
	"kn": ";",
	"kn_in": ";",
	"lt": ";",
	"lt_lt": ";",
	"lt_lt_preeuro": ";",
	"lv": ";",
	"lv_lv": ";",
	"lv_lv_preeuro": ";",
	"mk": ";",
	"mk_mk": ";",
	"ml_in": ";",
	"mr": ";",
	"mr_in": ";",
	"ms": ";",
	"ms_my": ";",
	"mt": ";",
	"mt_mt": ";",
	"mt_mt_preeuro": ";",
	"nb_no": ";",
	"nl": ";",
	"nl_be": ";",
	"nl_be_preeuro": ";",
	"nl_nl": ";",
	"nl_nl_preeuro": ";",
	"no": ";",
	"no_no": ";",
	"no_no_ny": ";",
	"or_in": ";",
	"pa": ";",
	"pa_in": ";",
	"pl": ";",
	"pl_pl": ";",
	"pl_pl_preeuro": ";",
	"pt": ";",
	"pt_br": ";",
	"pt_pt": ";",
	"pt_pt_preeuro": ";",
	"ro": ";",
	"ro_ro": ";",
	"ru": ";",
	"ru_ru": ";",
	"sh": ";",
	"sh_cs": ";",
	"sk": ";",
	"sk_sk": ";",
	"sk_sk_preeuro": ";",
	"sl": ";",
	"sl_si": ";",
	"sl_si_preeuro": ";",
	"sq": ";",
	"sq_al": ";",
	"sr": ";",
	"sr_ba": ";",
	"sr_ba_#latn": ";",
	"sr_cs": ";",
	"sr_me": ";",
	"sr_me_#latn": ";",
	"sr_rs": ";",
	"sr_rs_#latn": ";",
	"sr__#latn": ";",
	"sv": ";",
	"sv_se": ";",
	"sv_se_preeuro": ";",
	"ta": ";",
	"ta_in": ";",
	"te": ";",
	"te_in": ";",
	"th": ";",
	"th_th": ";",
	"th_th_th_#u-nu-thai": ";",
	"tr": ";",
	"tr_tr": ";",
	"uk": ";",
	"uk_ua": ";",
	"vi": ";",
	"vi_vn": ";"
	};

    
    static getDefaultLocale()
    {
    	return navigator.language;
    }
    
 
    
    static getListSeparator(locale)
    {
    	var lang = locale == null ? FormatSymbols.getDefaultLocale() : locale;
    	lang = lang.split("-").join("_");
    	var separator = FormatSymbols.CA_SUPPORTED[lang.toLowerCase()];
    	return 'undefined' == typeof separator ? "," : ";";
    }
 
}


// WEBPACK FOOTER //
// ./src/generated/FormatSymbols.js